import type { RelativeAbsolutePosition } from '../../../types/pointer-events.js';

export const capSelectionAtBoundaries = (
  boundaries: [RelativeAbsolutePosition, RelativeAbsolutePosition],
  width: number,
) => {
  const [selectionStart, selectionEnd] = boundaries;
  const start = {
    relative: {
      x: Math.max(selectionStart.relative.x, 0),
      y: selectionStart.relative.y,
    },
    absolute: selectionStart.absolute,
  };
  const end = {
    relative: {
      x: Math.min(selectionEnd.relative.x, width),
      y: selectionEnd.relative.y,
    },
    absolute: selectionEnd.absolute,
  };
  return { start, end };
};
